export const DATA_OPTION_PLACEHOLDER = 'No data available';

export default {
  DATA_OPTION_PLACEHOLDER,
};
